import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserLog } from '../../../../../models/users/user-log.model';
import { ErrorCodes } from '../../../../../enums/error/error-codes.enum';
import { UserLogsResultsResponse } from '../../../../../models/users/responses/api-users-logs-results-response.model';
import { ApiUsersService } from '../../../../../services/users/api/api-users.service';
import { AlertsService } from '../../../../../services/alerts.service';
import { DateService } from '../../../../../services/date.service';

@Component({
  selector: 'app-user-logs-tab',
  templateUrl: './user-logs-tab.component.html',
  standalone: true,
  imports: [CommonModule]
})
export class UserLogsTabComponent {

  @Input() userId: number = 0;

  protected readonly ErrorCodes = ErrorCodes;

  isLoading: boolean = false;

  expandedBodies = new Set<number>();
  expandedMessages = new Set<number>();

  toggleBody(logId: number): void { this.expandedBodies.has(logId) ? this.expandedBodies.delete(logId) : this.expandedBodies.add(logId); }
  toggleMessage(logId: number): void { this.expandedMessages.has(logId) ? this.expandedMessages.delete(logId) : this.expandedMessages.add(logId); }

  logs: UserLog[] = [];
  resultsPerPage: number = 25;
  pageNumber: number = 1;
  totalResults: number = 0;

  get totalPages(): number {
    return Math.ceil(this.totalResults / this.resultsPerPage);
  }

  getPageNumbers(): (number | null)[] {
    const total = this.totalPages;
    const current = this.pageNumber;

    const visibleSet = new Set<number>();
    for (let i = 1; i <= Math.min(2, total); i++) visibleSet.add(i);
    for (let i = Math.max(total - 1, 1); i <= total; i++) visibleSet.add(i);
    for (let i = Math.max(1, current - 2); i <= Math.min(total, current + 2); i++) visibleSet.add(i);

    const sorted = Array.from(visibleSet).sort((a, b) => a - b);

    const result: (number | null)[] = [];
    for (let i = 0; i < sorted.length; i++) {
      if (i > 0 && sorted[i] - sorted[i - 1] > 1) result.push(null);
      result.push(sorted[i]);
    }

    return result;
  }

  goToPage(page: number): void {
    this.pageNumber = page;
    this.refreshLogsList();
  }

  constructor(public dateService: DateService, private apiUsersService: ApiUsersService, private alertsService: AlertsService) {}

  load(): void {
    this.pageNumber = 1;
    this.refreshLogsList();
  }

  onClickPaginationPrevious(): void {
    this.pageNumber--;
    this.refreshLogsList();
  }

  onClickPaginationNext(): void {
    this.pageNumber++;
    this.refreshLogsList();
  }

  private refreshLogsList(): void {
    this.isLoading = true;

    this.apiUsersService.getUserLogs(this.userId, this.pageNumber, this.resultsPerPage).then(
      (response: UserLogsResultsResponse) => {
        this.isLoading = false;
        this.logs = response.results;
        this.totalResults = response.resultsTotal;
      }, error => {
        this.isLoading = false;
        this.alertsService.displayAlertError('Error loading logs (' + error + ')');
      }
    );
  }
}
